import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingKeys } from '@shared';
import { AccountPinComponent, AccountFusionPasswordComponent, AccountConnectionComponent } from './components';
import { AccountUsernameComponent } from './components/account-username';

const routes: Routes = [
	{
		path: '',
		component: AccountConnectionComponent
	},
	{
		path: AppRoutingKeys.urlPathRegistrationUsername,
		component: AccountUsernameComponent
	},
	{
		path: AppRoutingKeys.urlPathRegistrationFusionPassword,
		component: AccountFusionPasswordComponent
	},
	{
		path: AppRoutingKeys.urlPathRegistrationPin,
		component: AccountPinComponent
	}
];
@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AccountPageRoutingModule {}
